import {
  IThreeLayerID,
  IR2Paths,
  IEntityBase,
  IMetadata
} from '../types/base';
import { IOwnership } from '../types/ownership';
import { IVisibilityChild } from '../types/visibility';
import { IFork } from '../types/fork';
import { IVersionContainer } from '../types/version';
import { ITreeStructure } from '../types/tree';
import { ITriggerAction, createDefaultTriggerAction, triggerActionUtils } from './ITriggerAction';
import { mergeToDefaultData } from '../utils/mergeToDefaultData';
import { ulid } from 'ulid';

// === 类型常量 ===
export const triggerActionGroupType = 'triggerActionGroup'

/**
 * 触发器-动作组接口
 * 对应SQL表：project_trigger_action_group
 * 对应Go结构：ProjectTriggerActionGroup
 *
 * 触发器-动作组是一个容器，存储 TriggerAction（触发器-动作配对）的列表。
 * 每个 TriggerAction 关联一个 TriggerGroup（包含触发器集合）和一个 ActionGroup（包含动作集合）。
 *
 * list字段存储的是子trigger_action的ULID列表
 * children字段存储完整的子trigger_action对象列表（运行时填充）
 */
export interface ITriggerActionGroup extends
  IThreeLayerID,
  IEntityBase,
  IR2Paths,
  IOwnership,
  IVisibilityChild,
  IFork,
  IVersionContainer,
  ITreeStructure<ITriggerAction>,
  IMetadata
{
  // list字段继承自ITreeStructure，存储子trigger_action的ULID
  // children字段继承自ITreeStructure<ITriggerAction>，存储完整对象
}

// === 创建默认 TriggerActionGroup ===
export function createDefaultTriggerActionGroup(): ITriggerActionGroup {
  const triggerAction = triggerActionUtils.createDefaultData()
  const triggerActionGroupUlid = ulid()
  return {
    ulid: triggerActionGroupUlid,
    uuid: '',
    list: [triggerAction.ulid],
    // 初始化children（web端主要使用）
    children: [triggerAction],
    checks: [[true]],
    isSequential: false,
    createdAt: Date.now(),
    updatedAt: Date.now()
  } as ITriggerActionGroup
}

export function mergeTriggerActionGroupToDefaultData(data: Partial<ITriggerActionGroup>): ITriggerActionGroup {
  const result = mergeToDefaultData(createDefaultTriggerActionGroup, data)
  return result
}
